import { getAllData } from "apis/customApiHandler";
import { Fragment, useCallback, useEffect, useState } from "react";
import { useQuery } from "react-query";
import { Button, Input, Select } from "styled";
import { TD, TH } from "styled/table";
import { BiCloudDownload } from "react-icons/bi";
import axios from "apis/axios";
import ReactSelect from "react-select";
import { filterSelectStyles } from "utils/reactSelectStyles";
import Spinner from "components/Spinner";
import exportExcel from "utils/exportExcel";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import Modal from "components/Modal";

const DailyStencilDetail = () => {
  const ids = window.location.search.split("=")[1];
  const [selectedFleets, setSelectedFleets] = useState([]);
  const [selectedHubs, setSelectedHubs] = useState([]);
  const [dateFrom, setDateFrom] = useState("");
  const [dateTo, setDateTo] = useState("");
  const [page, setPage] = useState(1);
  const [kmFrom, setKmFrom] = useState("");
  const [kmTo, setKmTo] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [contractType, setContractType] = useState("All");
  const [alignment, setAlignment] = useState("All");
  const [rotation, setRotation] = useState("All");
  const [replacement, setReplacement] = useState("All");
  const [reportData, setReportData] = useState("")
  const [downloading, setDownloading] = useState(false)
  const [enabled, setEnabled] = useState(false)
  const [data, setData] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const getData = async (pg)=>{
    setIsLoading(true)
    const dt = await  getAllData("/report/stockReport", {
            ...(selectedFleets.length && {
              fleets: selectedFleets.map((fleet) => fleet).join(","),
            }),
            ...(selectedHubs.length && {
              hubs: selectedHubs.map((hub) => hub).join(","),
            }),
            ...(ids && {
              ids,
            }),
            ...(searchQuery && { searchQuery }),
            ...(contractType !== "All" && contractType !== "" && { contractType }),
            // dateFrom,
            // dateTo,
            kmFrom,
            kmTo,
          });
    // console.log(dt)
    setData(dt);
    setIsLoading(false)
  }
  useEffect(()=>{
    getData(page);
  }, [page])
  
  const { data: allFleets } = useQuery([`/customer-fleet`], () =>
    getAllData("/customer-fleet", {
      limit: 3000,
    })
  );
  const { data: allHubs } = useQuery([`/customer-hub`], () =>
    getAllData("/customer-hub", {
      limit: 3000,
    })
  );

  const getDownloadData = async ()=>{
    setDownloading(true)
    const dt = await getAllData("/report/stockReport", {
      ...(selectedFleets.length && {
        fleets: selectedFleets.map((fleet) => fleet).join(","),
      }),
      ...(selectedHubs.length && {
        hubs: selectedHubs.map((hub) => hub).join(","),
      }),
      ...(ids && {
        ids,
      }),
      ...(searchQuery && { searchQuery }),
      ...(contractType !== "All" && contractType !== "" && { contractType }),
      dateFrom,
      dateTo,
    });
    // console.log(dt)
    let xld = [] 
    dt?.data?.data && dt.data.data[0]?.map((x, idx) => {
      xld.push({
      "S.N": idx + 1,
      "Mobility": `${x.fleet} ${x.fleetCity ? `(${x.fleetCity})` : ""}`,
      "Owner": x?.isGrnTyre,
      "On Wheel": x?.fitted,
      "Reusable": x?.reusable,
      "Scrap": x?.scrap,
      "New Tyre": x?.newTyre,
      "Casing": x?.casing,
      "Greater than 8": x?.greaterThan8,
      "Between 4 and 8": x?.between4And8,
      "Less than 4": x?.lessThan4,
      "Total": x?.total,
    })}
    )
    dt?.data?.data && dt.data.data[1]?.map((x, idx) => {
      xld.push({
      "S.N": dt?.data?.data[0].length + idx + 1,
      "Mobility": `${x.fleet} ${x.fleetCity ? `(${x.fleetCity})` : ""}`,
      "Owner": x?.isGrnTyre,
      "On Wheel": x?.fitted,
      "Reusable": x?.reusable,
      "Scrap": x?.scrap,
      "New Tyre": x?.newTyre,
      "Casing": x?.casing,
      "Greater than 8": x?.greaterThan8,
      "Between 4 and 8": x?.between4And8,
      "Less than 4": x?.lessThan4,
      "Total": x?.total,
    })
  })
    exportExcel(
      xld,
      "DailyStencilDetail.xlsx"
    );
    setDownloading(false);
  }

  const getFleetOptions = useCallback(() => {
    if (allFleets && allFleets.data && allFleets.data.length) {
      return [
        {
          label: "Select All",
          value: "all",
        },
        ...allFleets?.data?.map((fleet) => {
          return {
            value: fleet._id,
            label: fleet.fleetName,
          };
        }),
      ];
    }
  }, [allFleets]);

  const getHubOptions = useCallback(() => {
    if (allHubs && allHubs.data && allHubs.data.length) {
      return [
        selectedFleets?.length && {
          label: "Select All",
          value: "all",
        },
        ...(allHubs?.data?.length &&
          allHubs?.data
            ?.filter((hub) => {
              const selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                selectedFleets?.includes(fleet._id)
              );

              return selectedFleetsVal?.some(
                (fleet) => fleet.fleetCode === hub.fleetCode
              );
            })
            ?.map((hub) => {
              return {
                value: hub._id,
                label: hub.hubName,
              };
            })),
      ];
    }
  }, [allFleets, allHubs, selectedFleets]);

  return (
    <div>
      <div className="flex flex-col text-gray-500">
        <div className="w-full px-8 flex justify-center items-end gap-4">
          <label className="w-full py-3 flex flex-col gap-2">
            Select Fleets
            <ReactSelect
              styles={filterSelectStyles}
              className="shadow-md rounded-md"
              options={getFleetOptions()}
              value={
                selectedFleets &&
                selectedFleets?.map((fleet) => {
                  return {
                    value: fleet,
                    label: allFleets?.data?.find((item) => item?._id === fleet)
                      ?.fleetName,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);

                if (allValues.includes("all")) {
                  setSelectedFleets(
                    allFleets?.data?.map((item) => {
                      return item._id;
                    })
                  );
                } else {
                  let selectedFleetsVal = allFleets?.data?.filter((fleet) =>
                    value?.map((item) => item.value)?.includes(fleet._id)
                  );

                  let selectedHubsVal = allHubs?.data?.filter((hub) =>
                    selectedHubs?.map((item) => item)?.includes(hub._id)
                  );

                  setSelectedHubs(
                    selectedHubsVal
                      ?.filter((hub) =>
                        selectedFleetsVal?.find(
                          (fleet) => fleet.fleetCode === hub.fleetCode
                        )
                      )
                      .map((hub) => hub._id)
                  );

                  setSelectedFleets(value.map((fleet) => fleet.value));
                }
              }}
              name="fleets"
              isMulti={true}
            />
          </label>

          <label className="w-full py-3 flex flex-col gap-2">
            Select Hubs
            <ReactSelect
              styles={filterSelectStyles}
              className="shadow-md rounded-md"
              options={getHubOptions()}
              value={
                selectedHubs &&
                selectedHubs?.map((hub) => {
                  return {
                    value: hub,
                    label: allHubs?.data?.find((item) => item._id === hub)
                      ?.hubName,
                  };
                })
              }
              onChange={(value) => {
                const allValues = value?.map((item) => item.value);

                if (allValues.includes("all")) {
                  setSelectedHubs((pre) =>
                    allHubs?.data
                      ?.filter((hub) => {
                        const selectedFleetsVal = allFleets?.data?.filter(
                          (fleet) => selectedFleets?.includes(fleet._id)
                        );
                        return selectedFleetsVal?.some(
                          (fleet) => fleet.fleetCode === hub.fleetCode
                        );
                      })
                      ?.map((hub) => hub._id)
                  );
                } else {
                  setSelectedHubs(value.map((hub) => hub.value));
                }
              }}
              name="hubs"
              isMulti={true}
            />
          </label>

          <Button type="button" className="mb-3" bgPrimary onClick={()=>getData(1)}>
            Search
          </Button>


        </div>
        <div className="w-full px-8 flex justify-start items-center gap-4">
          {/* <label>
            Start Date{" "}
            <Input
              type="date"
              name="dateFrom"
              value={dateFrom}
              onChange={(e) => setDateFrom(e.target.value)}
            />
          </label>
          <label>
            End Date{" "}
            <Input
              type="date"
              name="dateTo"
              value={dateTo}
              onChange={(e) => setDateTo(e.target.value)}
            />
          </label> */}

          {/* <Button type="button" bgPrimary onClick={()=>getData(1)}>
            Search
          </Button> */}
          {/* {downloading ?"Downloading..." : 
          <BiCloudDownload
          className="w-10 h-10 text-green-500 hover:scale-105 cursor-pointer text-center"
          onClick={async () => {
          await getDownloadData();
        }}
        />
          } */}
        </div>
        <div className="w-full px-8 flex justify-start items-center gap-4">

          
        </div>
      </div>

      {isLoading ? (
        <Spinner />
      ) : (
        <>
          {data && (
            <div className="flex flex-col m-2 lg:m-10">
              <div className="-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
                <div className="py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8">
                  <div className="shadow overflow-hidden border-b border-gray-200 sm:rounded-lg">
                    <table className="min-w-full divide-y divide-gray-200">
                      <thead className="bg-gray-50">
                        <tr>
                          <TH scope="col">S.N.</TH>
                          <TH scope="col">Mobility</TH>
                          <TH scope="col">Owner</TH>
                          <TH scope="col">On Wheel</TH>
                          <TH scope="col">Reuse</TH>
                          <TH scope="col">Scrap Type</TH>
                          <TH scope="col">New tyre</TH>
                          <TH scope="col">Casing</TH>
                          <TH scope="col">Greater than 8</TH>
                          <TH scope="col">Between 4 and 8</TH>
                          <TH scope="col">Less than 4</TH>
                          <TH scope="col">Total</TH>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {data && data.data?.length >0 && 
                          data.data[0]?.map((d, idx) => (
                            <ViewList length={0} data={d} idx={idx} />
                          ))}
                        {data && data.data?.length > 1 && 
                          data.data[1]?.map((d, idx) => (
                            <ViewList length={data.data[0].length ?? 0} data={d} idx={idx} />
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>

              {/* {data &&
                data.pageInfo &&
                data.pageInfo.total &&
                data.pageInfo.total > page * 20 && (
                  <div className="container mx-auto flex justify-center items-center gap-2 py-5">
                    <Button
                      onClick={() => {
                        setPage((p) => Math.max(p - 1, 1));
                      }}
                      disabled={page === 1}
                      className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                      primary
                    >
                      <div className="flex gap-1 items-center">
                        <IoMdArrowBack />
                        Prev Page
                      </div>
                    </Button>
                    <span className="text-gray-600 px-4">{`showing: ${
                      (page - 1) * 20 + 1
                    } - ${page * 20} of ${data.pageInfo.total}`}</span>

                    <Button
                      onClick={() => {
                        setPage((p) => Math.min(p + 1, data?.pageInfo?.total));
                      }}
                      disabled={page === data?.pageInfo?.total}
                      className="disabled:pointer-events-none disabled:opacity-70 px-0 "
                      primary
                    >
                      <div className="flex gap-1 items-center">
                        Next Page
                        <IoMdArrowForward />
                      </div>
                    </Button>
                  </div>
                )} */}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default DailyStencilDetail;

const ViewList = ({ data, idx, length }) => {
  const [showModal, setShowModal] = useState(false);
  const [modalData, setModalData] = useState([]);
  const handleClick = async () => {
    const url = `/inspection/${data.inspectionId}?download=1`;

    //download file from that url
    const response = await axios.get(url, {
      responseType: "blob",
    });

    const url2 = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement("a");
    link.href = url2;
    link.setAttribute("download", "inspection.pdf");
    document.body.appendChild(link);
    link.click();
  };

  const modalHandler = useCallback(
    (data) => {
      if (data) {
        setModalData(data);
        setShowModal(true);
      } else {
        setShowModal(false);
        setModalData([]);
      }
    },
    [showModal, modalData]
  );

  const fetchFile = async (url) => {
    const originalImage = url;
    const image = await fetch(originalImage);

    //Split image name
    const nameSplit = originalImage.split("/");
    const duplicateName = nameSplit.pop();

    const imageBlog = await image.blob();
    const imageURL = URL.createObjectURL(imageBlog);
    const link = document.createElement("a");
    link.href = imageURL;
    link.download = "" + duplicateName + "";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Fragment>
      {showModal && (
        <Modal
          handleClick={() => setShowModal(false)}
          title={"Vehicle Information"}
          className="max-w-2xl"
        >
          {/* <h1>This is the modal</h1> */}
          <table className="min-w-full divide-y divide-gray-200">
            <thead className="bg-gray-50">
              <tr>
                <TH scope="col">S.N.</TH>
                <TH scope="col">Tyre Position</TH>
                <TH scope="col">Previous Stencil</TH>
                <TH scope="col">Current Stencil</TH>
              </tr>
            </thead>
            <tbody>
              {modalData.map((item, index) => (
                <tr>
                  <TD>{index + 1}</TD>
                  <TD>{item.tyre.curr.position}</TD>
                  <TD>{item.tyre.prev.stencilNo}</TD>
                  <TD>{item.tyre.curr.stencilNo}</TD>
                </tr>
              ))}
            </tbody>
          </table>
        </Modal>
      )}
      <tr className={`${idx % 2 !== 0 && "bg-gray-100"}`}>
        <TD>{length + (idx + 1)}</TD>
        <TD>{data?.fleet} {data?.fleetCity ? `(${data.fleetCity})` : ""}</TD>
        <TD>{data?.isGrnTyre}</TD>
        <TD>{data?.fitted}</TD>
        <TD>{data?.reusable}</TD>
        <TD>{data?.scrap}</TD>
        <TD>{data?.newTyre}</TD>
        <TD>{data?.casing}</TD>
        <TD>{data?.greaterThan8}</TD>
        <TD>{data?.between4And8}</TD>
        <TD>{data?.lessThan4}</TD>
        <TD>{data?.total}</TD>

      </tr>
    </Fragment>
  );
};
